/**
 * Purpose:
 *   Renders menu item icon with fixed positioning.
 */

import { Icon } from '@/components/ui/icon/Icon';

export interface IMenuItemIconProps {
  icon: string;
  size?: number;
  style?: React.CSSProperties;
}

export function MenuItemIcon({ icon, size = 20, style }: IMenuItemIconProps) {
  return (
    <span style={style}>
      <Icon src={icon} size={size} preserveColors aria-hidden />
    </span>
  );
}
